<template>
  <view>
    <result-page-c wx:if="{{isShowResultC}}" config="{{pageConfig.result}}" rewardList="{{couponList || []}}" bind:couponToUse="couponToUse"/>
    <result-page-b wx:elif="{{isShowResultB}}" config="{{pageConfig.resultB}}" indexConfig="{{pageConfig.index}}" rewardList="{{couponList || []}}" bind:couponToUse="couponToUse" bind:toUseCoupon="toUseCoupon"/>
    <view class="warp" wx:style="{{warpStyle2}}" wx:else>
      <block wx:if="{{!error}}">
        <text class="rule" wx:style="{{ruleStyle}}" bindtap="gotoLink(pageConfig.rule.link)">规则</text>
        <red-packet-close
          wx:if="{{activityCouponInfo}}"
          config="{{redPacketConfig}}"
          couponInfo="{{activityCouponInfo}}"
          btnText="{{btnText}}"
          bind:click="getCoupon"
        />
        <res-banner wx:if="{{activityCouponInfo}}" template="{{info.template}}" />
      </block>
      <error-view wx:else error="{{error}}" message="{{errmsg}}" />
    </view>
    <toast wx:if="{{toast.show}}" icon="{{toast.icon}}" content="{{toast.content}}"/>
  </view>
</template>

<script>
import mpx, { createComponent } from '@mpxjs/core'
import { props as properties } from './model/props'
import { chapter, initLogin, getEnvParams } from '../../lib/utils'
import store from '../../lib/store'
import couponMixin from '../../lib/mixin/coupon-v3'
import { getStyle } from '../../lib/editor/utils'
import api from '../../lib/service'

import {
  is,
  utils,
  goTo,
  xenv,
  sendXspmScan,
  // eslint-disable-next-line prettier/prettier
  trackEvent
} from '@didi/webx-js'

createComponent({
  properties,
  mixins: [ couponMixin ],
  data: {
    style: {},
    redPacketConfig: {},
    showResultPageC: false,
    showResultPageB: false,
    toast: {
      show: false,
      icon: 'success',
      content: '',
    },
  },
  attached() {
    // redPacketConfig.style 已经被线上使用过
    this.formatPageConfig && this.formatPageConfig()
    const showFriday = (process.env.MODE === 'editor' && this.pageConfig.friday?.mockEnable) || ([ 5,6,0 ].includes(new Date().getDay())&& this.pageConfig.friday?.enable)
    if (showFriday){
      this.style = this.pageConfig.friday.style
      this.pageConfig.friday.redPacket && (this.redPacketConfig.style = this.pageConfig.friday.redPacket.style)
    }
  },
  computed: {
    ...store.mapGetters([ 'cityInfo', 'query', 'initData' ]),
    warpStyle2() {
      if (this.error) {
        return {
          ...getStyle(this.style),
          backgroundImage: undefined,
        }
      }
      return getStyle(this.style)
    },
    btnText() {
      if (this.pageConfig.resultB?.enable) {
        return this.isShowResultB ? this.pageConfig.index.button.gotoText : this.pageConfig.index.button.text
      }
      return this.hasGetCoupon ? this.pageConfig.index.button.gotoText : this.pageConfig.index.button.text
    },
    isShowResultC() {
      if (process.env.MODE === 'editor') {
        return this.pageConfig.result?.show
      }
      return this.showResultPageC
    },
    isShowResultB() {
      if (process.env.MODE === 'editor') {
        return this.pageConfig.resultB?.show
      }
      return  this.showResultPageB
    },
  },
  methods: {
    formatPageConfig() {
      this.pageConfig.redPacket.style = this.pageConfig.redPacket.style2
      this.redPacketConfig = this.pageConfig.redPacket
      this.style = this.pageConfig.index.style
      if (!this.pageConfig.redPacket.style || !this.pageConfig.redPacket.style.marginTop) {
        this.redPacketConfig.style = {
          marginTop: 380,
        }
      }
      if (!this.pageConfig.index.style.backgroundImage) {
        this.style.backgroundImage = utils.webpUrl('https://ut-static.udache.com/webx/ut/nSqi0nEtIckBw3GBYHDp4.png')
      }
    },
    // B端活动
    async getBusinessCoupon(res) {
      if (res.errno !== 0) {
        let duration = 1400
        if (res.errno  === 4000400001) {
          this.error = 4000400001
          this.errmsg = res.errmsg
          duration = 1000
        } else {
          mpx.showToast({
            title: res.errmsg,
            icon: 'none',
            mask: true,
          })
        }
        setTimeout(() => {
          this.toUseCoupon({ isAuto: true })
        }, duration)
      } else {
        this.toast = {
          show: true,
          icon: 'success',
          content: '领取成功跳转中～\n在【我的-优惠券】中查看',
        }
        const params = {
          dsi: this.query.dsi,
          source_id: this.query.source_id,
        }
        setTimeout(() => {
          this.toast.show = false
          if (__mpx_mode__ === 'web') {
            if (xenv() === 'passenger') {
              this.toUseCoupon({ isAuto: true })
            } else if (is('miniprogram')) {
              goTo({ path: '/home/pages/index?channel=1100080641', params  })
            } else {
              const url = this.curEnv === 'ali' ? 'https://v.didi.cn/p/ZPDQZm7' : 'https://v.didi.cn/oZ6j93w'
              goTo({
                  url,
                  params,
                  extParams: {
                    noCompileDchn: true,
                  },
              })
            }
          } else {
            goTo({ path: '/home/pages/index?channel=1100080641', params  })
          }
        }, 1400)
      }
    },
    // B端活动结果页
    async getBusinessResultCoupon(res) {
      if (res.errno  === 4000400001) {
        this.error = 4000400001
        this.errmsg = res.errmsg
        return
      }
      if (res.errno !== 0) {
        mpx.showToast({
          title: res.errmsg,
          icon: 'none',
          mask: true,
        })
      } else {
        mpx.showToast({
          title: '领券成功',
          icon: 'success',
          mask: true,
        })
      }
      await this.getRewardList()
      if (this.couponList?.length) {
        this.showResultPageB = true
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].toUseBtn,
            d: '',
          }
        )
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].couponToUseBtn,
            d: '',
          }
        )
      }
    },
    // C端活动
    async getConsumerCoupon(res) {
      if (res.errno  === 4000400001) {
        this.error = 4000400001
        this.errmsg = res.errmsg
        return
      }
      if (res.errno !== 0) {
        mpx.showToast({
          title: res.errmsg,
          icon: 'none',
          mask: true,
        })
      } else {
        mpx.showToast({
          title: '领券成功',
          icon: 'success',
          mask: true,
        })
      }
      await this.getRewardList()
      if (this.couponList?.length) {
        this.showResultPageC = true
        sendXspmScan(
          {},
          {
            a: '',
            b: this.info.template,
            c: chapter[this.info.template].toUseBtn,
            d: '',
          }
        )
      }
    },
    getCoupon: utils.debounce(
      async function(e, showLoading = true, wxOauth) {
        showLoading && trackEvent('userteam_ddlm_coupon_bt_ck', '领券页面-按钮-点击')
        if (this.doingGetCoupon || this.toast.show) return
        // 理论上不会执行到，看情况删除
        if (this.hasGetCoupon && !this.pageConfig.resultB?.enable) {
          return this.toUseCoupon()
        }
        this.doingGetCoupon = true
        await initLogin({
          needLogin: true,
          wxOauth: wxOauth !== undefined ? wxOauth : this.info.wxOauth,
          redirectParams: {
            is_back: '1',
          },
        }).catch(e => {
          this.doingGetCoupon = false
          throw e
        })
        trackEvent('userteam_fx_home_bt_ck', '立即领取', {
          bt_text: this.btnText,
          action: 'ljlq',
        })
        showLoading &&
          mpx.showLoading({
            mask: true,
          })
        const envInfo = await getEnvParams(e)
        const res = await api.getCoupon({
          source_from: this.query.source_from || '', // 通过 保存的海报 进入页面
          // 口令
          pwd_type: this.query.pwd_type,
          exchange_pwd: this.query.exchange_pwd,
          env: envInfo,
          req_env: this.curEnv,
          dunion_callback: this.query.dunion_callback || '',
        })
        this.doingGetCoupon = false
        mpx.hideLoading()
        // C端活动
        if (this.initData.activity_info?.promotion_type === 'personal') {
          this.getConsumerCoupon(res)
        } else if (this.pageConfig.resultB?.enable){
          this.getBusinessResultCoupon(res)
        } else {
          this.getBusinessCoupon(res)
        }
        this.hasGetCoupon = true
      },
      800,
      true
    ),
  },
})
</script>

<style lang="stylus" scoped>
  .warp
    min-height 100vh
    width 100vw
    padding-bottom 72rpx
    overflow hidden
    box-sizing: border-box;
    background-size 100vw auto
    background-repeat no-repeat
    line-height: normal;
    position relative
    .rule
      position absolute
      right 0
      border-radius: 100rpx 0 0 100rpx;
      font-family: PingFangSC-Semibold;
      font-size: 24rpx;
      letter-spacing: 1rpx;
      font-weight: bold
      padding 4rpx 16rpx 4rpx 25rpx
</style>

<script name="json">
const config = {
  "component": true,
  "usingComponents": {
    "red-packet-close": "../../components/wyc/red-packet-close.mpx",
    "res-banner": "../../components/common/res-banner.mpx",
    "error-view": "../../components/common/error-view.mpx?async=error-view",
    "result-page-c": "../../components/wyc/result-page.mpx",
    "result-page-b": "../../components/wyc/result-page-b.mpx",
    "toast": "../../components/common/toast.mpx"
  }
}
module.exports = config
</script>
